import { FormProvider, useForm, useWatch } from "react-hook-form";
import React from "react";
import {
  Checkbox,
  FormGroup,
  SubmitButton,
} from "../../../../@coherent/react-hook-form";
import { TextQuestion } from "../../components/TextQuestion";
import { Button } from "reactstrap";
import { YesNoRadioQuestion } from "../../../../@coherent/react-hook-form";
import { Trans, useTranslation } from "react-i18next";

export const Step5Form = ({ required = true }) => {
  const { t } = useTranslation();
  const { dietary_requirements, medical_conditions, training_other } = useWatch(
    {
      name: ["dietary_requirements", "medical_conditions", "training_other"],
    }
  );

  return (
    <>
      <h3 className="tw-text-lg mb-4">Session Registration Details</h3>
      <p>
        <Trans>
          Thank you for completing your volunteer application form, please
          provide a few more details that will enable us to register you at our
          Make Lunch events.
        </Trans>
      </p>
      <p>
        <Trans>
          Please provide emergency contact details should we need to contact
          anyone on your behalf during a session:
        </Trans>
      </p>
      <TextQuestion
        name="emergency_contact_name"
        label={t("Emergency contact name")}
        required={required}
      />
      <TextQuestion
        name="emergency_contact_number"
        label={t("Emergency contact number")}
        required={required}
      />

      <YesNoRadioQuestion
        name="dietary_requirements"
        label={t(
          "Do you have any dietary requirements that we should know about?"
        )}
        required
      >
        {dietary_requirements === "Yes" && (
          <TextQuestion
            name="dietary_requirements_detail"
            label={t("Please provide details")}
            required
          />
        )}
      </YesNoRadioQuestion>
      <YesNoRadioQuestion
        name="medical_conditions"
        label={t("Do you have any Medical conditions we need to be aware of?")}
        required
      >
        {medical_conditions === "Yes" && (
          <TextQuestion
            name="medical_conditions_detail"
            label={t("Please provide details")}
            required
          />
        )}
      </YesNoRadioQuestion>
      <FormGroup
        label={t(
          "Do you have any current training qualifications that might be relevant at the Make Lunch Club?"
        )}
      >
        <FormGroup
          check
          htmlFor="training_first_aid"
          label={t("First Aid certificate")}
        >
          <Checkbox
            name="training_first_aid"
            id="training_first_aid"
            className="form-check-input"
          />
        </FormGroup>
        <FormGroup
          check
          htmlFor="training_food_hygiene"
          label={t("Food Hygiene certificate")}
        >
          <Checkbox
            name="training_food_hygiene"
            id="training_food_hygiene"
            className="form-check-input"
          />
        </FormGroup>
        <FormGroup check htmlFor="training_other" label={t("Other")}>
          <Checkbox
            name="training_other"
            id="training_other"
            className="form-check-input"
          />
        </FormGroup>
      </FormGroup>
      {training_other ? (
        <TextQuestion
          name="training_other_detail"
          label={t("Please provide details")}
          required
        />
      ) : null}
    </>
  );
};

export const Step5 = ({ onSubmit, defaultValues, onBack }) => {
  const methods = useForm({
    mode: "onBlur",
    defaultValues,
    shouldUnregister: true,
  });
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Step5Form />
        <div className="tw-flex tw-justify-between">
          <Button onClick={onBack}>Back</Button>
          <SubmitButton>Continue</SubmitButton>
        </div>
      </form>
    </FormProvider>
  );
};
